<template>
  <section class="contact page">

    <h2 v-if="isMsgSent" class="text-center">Mesaj trimis cu succes.</h2>

    <form v-else=""
          @submit.prevent="submit">
      <h4 class="text-center">{{ contact.title }}</h4>

      <label class="capitalize"
             for="nume">{{ contact.name }}:</label>
      <input id="nume"
             name="name"
             type="text"
             v-model="data.name"
             v-validate="'required'"
             :placeholder="contact.name">
      <span class="alert">{{ errors.first('name') }}</span>

      <label class="capitalize"
             for="email">{{ contact.email }}:</label>
      <input id="email"
             name="email"
             v-model="data.email"
             v-validate="'required|email'"
             type="email"
             :placeholder="contact.email">
      <span class="alert">{{ errors.first('email') }}</span>

      <label class="capitalize"
             for="msg">{{ contact.message }}:</label>
      <textarea id="msg"
                class="pleft10px"
                name="message"
                v-model="data.msg"
                v-validate="'required'"
                :placeholder="contact.message">
      </textarea>
      <span class="alert">{{ errors.first('message') }}</span>

      <button type="submit"
              class="contact-btn flex">TRIMITE</button>
    </form>

    <subscribe />
  </section>
</template>

<script>
  import {mapState} from 'vuex'
  import Subscribe from '../components/Subscribe.vue'
  export default {
    name: 'contact',
    data() {
      return {
        contact: {
          title: 'Adresează-ne o întrebare:',
          name: 'nume',
          email: 'email',
          message: 'mesaj'
        },
        data: {
          name: '',
          email: '',
          msg: ''
        },
        isMsgSent: false
      }
    },
    computed: {
      ...mapState({})
    },
    methods: {
      submit () {
        this.$validator.validate().then(result => {
          const clbk = () => {
            this.isMsgSent = true
            this.data = {}
          }
          result && this.$store.dispatch('send_msg', {data: this.data, clbk})
        })
      }
    },
    components: {
      Subscribe
    }
  }
</script>

<style lang="less">
  .contact {
    form {
      max-width: 600px;
      padding: 0 20px;
      margin: auto;
    }
    h4 {
      font-size: 2rem;
      font-weight: 400;
    }
  }
</style>